//
//
//
//
//
//
//
//

import NavBar from '../components/NavBar'
import TabBar from '../components/TabBar'
import Foot from '../components/Foot'
export default {
  components: {
    NavBar,
    TabBar,
    Foot
  },
  data () {
    return {
      navbar: null
    }
  },
  beforeMount () {
    // window.addEventListener('scroll', this.scrollChecker)
  },
  mounted () {
    this.navbar = this.$el.querySelector('.navbar')
    this.scrollChecker()
    this.$store.commit('INIT_SET_Store')
    // this.$auth.logout()
  },
  methods: {
    scrollChecker () {
      if (window.innerWidth > 400) {
        if (window.pageYOffset > 0) {
          this.navbar.classList.add('navBg')
        } else {
          this.navbar.classList.remove('navBg')
        }
      }
    }
  },
  head () {
    return {
      titleTemplate: `%s - ${this.$config.STORE_NAME}`,
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
        {
          hid: 'og:title',
          name: 'og:title',
          template: tit => tit ? `${tit} - ${this.$config.STORE_NAME}` : `${this.$config.STORE_NAME}`
        },
        {
          hid: 'description',
          name: 'description',
          template: des => des ? `${des} - ${this.$config.STORE_DESCRIPTION} ${this.$config.STORE_NAME}` : `${this.$config.STORE_DESCRIPTION} ${this.$config.STORE_NAME}`
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'carteras, bolsos, calzados, medias, ropa niños y dama, pijamas, morrales, paños, trajes de baño, medias panties, pantuflas, camisas, pantalones, loncheras, batas, sudaderas, enterizos, ropa de bebe, calzado de bebe, ropa intima caballero y dama, sostenes, boxers, interiores, suéters, chaquetas, fajas de dama, panties, panty medias, mallas'
        }
      ],
      link: [
        { rel: 'icon', type: 'image/x-icon', href: `/${this.$config.STORE_FAVICON}.ico` },
        { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500&family=Oswald:wght@700&family=Roboto:wght@100;300;500&display=swap' },
        { rel: 'stylesheet', href: 'https://unpkg.com/boxicons@2.1.4/css/boxicons.min.css' },
        { rel: 'canonical', href: this.$config.WEB_URL }
      ]
    }
  }
}
